var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1665 2H14.1665L20.1665 8V20C20.1665 21.1 19.2665 22 18.1665 22H6.1565C5.0565 22 4.1665 21.1 4.1665 20L4.1765 4C4.1765 2.9 5.0665 2 6.1665 2ZM6.1665 4V20H18.1665V9H13.1665V4H6.1665Z",
    fill: "#2771bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1665 15H9.1665C9.7165 15 10.1665 14.55 10.1665 14V13C10.1665 12.45 9.7165 12 9.1665 12H7.1665V17H8.1665V15ZM14.1665 16V13C14.1665 12.45 13.7165 12 13.1665 12H11.1665V17H13.1665C13.7165 17 14.1665 16.55 14.1665 16ZM12.1665 13H13.1665V16H12.1665V13ZM17.1665 15H16.1665V17H15.1665V12H17.1665V13H16.1665V14H17.1665V15ZM9.1665 13H8.1665V14H9.1665V13Z",
    fill: "#2771bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3fc8aba90d3cd698de0b375dd9d07c35.svg";
export { ForwardRef as ReactComponent };